
import moment from 'moment'
import axios from 'axios'
import axiosClient from '../../http'
import store from '../../config/store'

export default {
  components: {
    'component-avis': () => import(/* webpackChunkName: "statements" */ './Avis.vue'),
    'component-swift': () => import(/* webpackChunkName: "statements" */ './Swift.vue'),
    'component-placeholder': () => import(/* webpackChunkName: "components" */ '../../components/Placeholder.vue')
  },

  data: () => ({
    store,
    year: moment().year(),
    years: [],
    statements: [],
    activeTab: 'all',
    cancelRequest: null
  }),

  computed: {
    hasResult () {
      return this.statements.length
    },

    isAll () {
      return this.activeTab === 'all'
    },

    isAvis () {
      return this.activeTab === 'avis'
    },

    isSwift () {
      return this.activeTab === 'swift'
    }
  },

  watch: {
    year () {
      this.getStatements()
    },
    'store.data.user.account.uuid': function () {
      this.getStatements()
    }
  },

  mounted () {
    moment.locale(store.data.lang)
    this.getYearsList()
    this.getStatements()
  },

  methods: {
    getYearsList () {
      this.years = []
      for (var i = moment().year(); i >= moment(store.data.user.account.opening_date).year(); i--) {
        this.years.push(i)
      }
    },
    getStatements () {
      const typeFilter = this.isAll ? '' : `&type=${this.activeTab}`
      axiosClient.get(`/statements?year=${this.year}${typeFilter}`, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest = c)
      }).then(r => {
        this.statements = r.data
      }, () => {

      })
    },
    monthLabel (month) {
      let monthLabel = moment.months(month - 1)
      monthLabel = monthLabel.charAt(0).toUpperCase() + monthLabel.slice(1)
      return monthLabel
    },
    downloadStatement (url) {
      url = url.replace('http://', 'https://')
      this.downloadFileFromUrl(url)
    },

    toggleTab (tab) {
      if (tab !== this.activeTab) {
        this.cancelRequest()
        this.activeTab = tab
        this.getStatements()
      }
    }
  }
}
